export enum RadioDisplayType {
  mobile = 'mobile',
  desktop = 'desktop'
}


export enum RadioDisplay {
  stacked = 'stacked',
  inline = 'inline'
}
